import {styled} from '../../styled-components';

export const TableBodyStyle = styled.tbody`
    display: table-row-group;
`;
